export default __webpack_public_path__ + "static/media/LamborghiniHuracane.8ee28e5b.jpg";